export const FETCH_STUDENT_PROGRESS_REQUEST = 'ADMIN_FETCH_STUDENT_PROGRESS_REQUEST';
export const FETCH_STUDENT_PROGRESS_SUCCESS = 'ADMIN_FETCH_STUDENT_PROGRESS_SUCCESS';
export const FETCH_STUDENT_PROGRESS_FAILURE = 'ADMIN_FETCH_STUDENT_PROGRESS_FAILURE';

export const EXPORT_PROGRESS_REPORT_REQUEST = 'ADMIN_EXPORT_PROGRESS_REPORT_REQUEST';
export const EXPORT_PROGRESS_REPORT_SUCCESS = 'ADMIN_EXPORT_PROGRESS_REPORT_SUCCESS';
export const EXPORT_PROGRESS_REPORT_FAILURE = 'ADMIN_EXPORT_PROGRESS_REPORT_FAILURE';

export const SET_PROGRESS_FILTERS = 'ADMIN_SET_PROGRESS_FILTERS';
export const CLEAR_PROGRESS_FILTERS = 'ADMIN_CLEAR_PROGRESS_FILTERS';
